import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import '../../css/autosuggest.css';
import Highlighter from "react-highlight-words"
import DatosAreasGeo from "../../utilidades/areasgeograficas.json";
import latinize from 'latinize';
export default function CajaBuscador(){
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const _updateBotonClic= useStoreGlobal(useShallow((state) => state._updateBotonClic));
    const _updateAreasGeo= useStoreGlobal(useShallow((state) => state._updateAreasGeo));
    const _updatePage= useStoreGlobal(useShallow((state) => state._updatePage));
    const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const _updateradioBie= useStoreGlobal(useShallow((state) => state._updateradioBie));
    const _radioBie = useStoreGlobal(useShallow((state) => state._radioBie));
    const [estaActivo, setEstaActivo] = useState(0);
    const inputQ = useRef(null);
    const [showLimpiar, setShowLimpiar] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const inputRef = useRef(null);
    let coleccion = "";
    if(Object.keys(_filtros).length > 0){
        coleccion = _filtros.coleccion;
    }
    const keyUp = (event) => {
        _updateAreasGeo({valorAreaFinal: ""});
        let campo = document.getElementById('inputQ').value.trim().replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        let keyCode =event.keyCode;
        if (keyCode == 8) {
            // _updateBotonClic({botonConsulta: estaActivo});
            if (campo == "") {
                setShowLimpiar(false);
            }
        }
        else{
            setShowLimpiar(true);
        }
        if (keyCode == 13) {
            if (campo !== "") {
                setEstaActivo(1);
                _updateBotonClic({botonConsulta: estaActivo});
                if(campo.length >2){
                if ((coleccion == "Indicadores") || (coleccion == "Todo")){
                    fetchData(campo);
                }
                else{
                    _updateAreasGeo({valorAreaFinal: "null"});
                }
        }
            }
            if(campo.length >=2){
                _updateFiltros({textoBusqueda: campo});
            }
        }
        if((keyCode != 40) && (keyCode != 38) && (keyCode != 39) && (keyCode != 37) && (keyCode != 13)){
            if(campo.length >=2){
                const delayDebounce = setTimeout(() => {
                fetchDataSug(campo);
            }, 300);
                return () => clearTimeout(delayDebounce);
            }
        }
    };
    let apiEndpoint = "/app/api/buscadorcore/v1/Sugerencias/";
    const fetchDataSug = async (query) => {
        try {
            let numColeccion = 0;
            if (coleccion === "Areageograficas") {
                numColeccion = 2;
            }
            if (coleccion === "Datos_abiertos") {
                numColeccion = 27;
            }
            if (coleccion === "DENUE") {
                numColeccion = 13;
            }
            if (coleccion === "Glosario") {
                numColeccion = 14;
            }
            if (coleccion === "Herramientas") {
                numColeccion = 19;
            }
            if (coleccion === "Indicadores") {
                numColeccion = 3;
            }
            if (coleccion === "Infraestructura") {
                numColeccion = 31;
            }
            if (coleccion === "Investigación") {
                numColeccion = 28;
            }
            if (coleccion === "Mapas") {
                numColeccion = 6;
            }
            if (coleccion === "Microdatos") {
                numColeccion = 26;
            }
            if (coleccion === "Noticias") {
                numColeccion = 30;
            }
            if (coleccion === "Publicaciones") {
                numColeccion = 5;
            }
            if (coleccion === "Programas") {
                numColeccion = 7;
            }
            if (coleccion === "Tabulados") {
                numColeccion = 21;
            }
            if (coleccion === "BIE") {
                numColeccion = 9;
            }
            if (coleccion === "Temas") {
                numColeccion = 8;
            }
            const response = await fetch(`${apiEndpoint}es/${query}/${numColeccion}/ranking/cbusqueda`);
            const data = await response.json();
            setSuggestions(data);
            setActiveIndex(-1);
        } catch (error) {
            console.error("Error fetching data:", error);
            setSuggestions([]);
        } 
    };
    function quitarAcentos(cadena) {
        const acentos = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U' };
        return cadena.split('').map(letra => acentos[letra] || letra).join('').toString();
    }
    const fetchData = async (query) => {
        try {
                for (const item of DatosAreasGeo) {
                    let datoTitulo = item.TITULO;
                    datoTitulo= datoTitulo.replace("san", "").toLowerCase();
                        if(datoTitulo.includes("pib") || datoTitulo.includes("casa") || datoTitulo.includes("casas") ||
                            datoTitulo.includes("maiz") || datoTitulo.includes("maíz") || datoTitulo.includes("paz")||
                            datoTitulo.includes("hidalgo") || datoTitulo.includes("libertad") ||
                            datoTitulo.includes("espinoza") || datoTitulo.includes("dr") || datoTitulo.includes("leon")
                            ){
                            _updateAreasGeo({valorAreaFinal: "null"});
                        }
                        else{
                            let sinAcentos= quitarAcentos(datoTitulo);
                            query= quitarAcentos(query);
                            if (query.includes(sinAcentos)){
                                if(datoTitulo.includes("pib") || datoTitulo.includes("casa") || datoTitulo.includes("casas") ||
                                    datoTitulo.includes("maiz") || datoTitulo.includes("maíz") || datoTitulo.includes("paz")||
                                    datoTitulo.includes("hidalgo") || datoTitulo.includes("libertad") ||
                                    datoTitulo.includes("espinoza") || datoTitulo.includes("dr") || datoTitulo.includes("leon")
                                ){
                                    
                                    _updateAreasGeo({valorAreaFinal: "null"});
                                }
                                else{
                                    _updateAreasGeo({valorAreaFinal: item.UBICACION_GEOGRAFICA});
                                    break;
                                }
                            }
                        }
                }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en."
    }
    const handleClick2 = (e) => {
        let nodoTooltip = document.querySelectorAll('[role="tooltip"]');
        nodoTooltip.forEach(element => {
            element.remove();
        });
        _updateAreasGeo({valorAreaFinal: ""});
        let campo = decodeURIComponent(document.getElementById('inputQ').value.trim()).replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        setInputValue(decodeURIComponent(campo));
        e.preventDefault();
        if(campo.length >=2){
            _updateFiltros({textoBusqueda: campo});
        }
        setEstaActivo(1);
        _updateBotonClic({botonConsulta: estaActivo});
        if(campo.length >2){
            if ((coleccion == "Indicadores") || (coleccion == "Todo")){
                fetchData(campo);
            }
            else{
                _updateAreasGeo({valorAreaFinal: "null"});
            }
        }
        setTimeout(() => { 
            if(_filtros.paginaInicial == 0){
                _updatePage({page: 1});
                _updateFiltros({paginaInicial: 0});
            }
        }, 2500);
    }
    const handleClick = (e) => {
        let nodoTooltip = document.querySelectorAll('[role="tooltip"]');
        nodoTooltip.forEach(element => {
            element.remove();
        });
        e.preventDefault();
        _updateBotonClic({botonConsulta: 0});
        setInputValue("");
        document.getElementById('inputQ').value = "";
        setShowLimpiar(false);
        _updateFiltros({textoBusqueda: ""});
        document.getElementById('result').style.display = "none";
        if(document.getElementById('bottom-navigation')){
            document.getElementById('bottom-navigation').style.display = "none";
        }
        document.getElementById('resultados').innerHTML= 0;
        document.getElementById('ResultadosTotales').style.display = "none";
        if(document.getElementById('informacionEncontrados')){
            document.getElementById('informacionEncontrados').style.display = "none";
        }
    }
    const handleKeyDown = (e) => {
        // Arrow down
        if (e.key === 'ArrowDown' && activeIndex < suggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
            setInputValue(suggestions[activeIndex + 1]?.TITULO);
            $("#Sugerencias li").eq(activeIndex + 1).trigger("focus");
        }
        // Arrow up
        else if (e.key === 'ArrowUp' && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
            setInputValue(suggestions[activeIndex - 1]?.TITULO);
            $("#Sugerencias li").eq(activeIndex + 1).trigger("focus");

        }
        // Enter
        else if (e.key === 'Enter' && activeIndex >= 0) {
            e.preventDefault();
            handleSuggestionClick(suggestions[activeIndex]);
        }
    };
    const handleInputChange = (event) => {
        setInputValue(decodeURIComponent(event.target.value));
    };
    const handleSuggestionClick = (suggestion) => {
        if (suggestion !== undefined){
            setInputValue(suggestion.TITULO);
            setSuggestions([]);
            inputRef.current.focus();
        }
    };      
    const handleClickOutside = () => {
        setSuggestions([]); 
    };
    const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (let i=0; i< textInputAux.length; i++) {
            if(i==0){
                concatena.push(`${textInputAux[i]}`); 
            }
            else{
                concatena.push(`${textInputAux[i]}`); 
            }
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    highlightStyle={{ fontWeight:"bold",backgroundColor:"transparent"}}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
        return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
    let urlHome = "";
    if (window.location.href.indexOf("?q=") > -1) {
        const decodedString = decodeURIComponent(window.location.href);
        let referSplit = decodedString.split("?q=");
        urlHome = decodeURIComponent(referSplit[1]);
    }
    useEffect(() => {
        if(_radioBie.textoBusqueda != ""){
            setInputValue(decodeURIComponent(_radioBie.textoBusqueda ));
            _updateradioBie({textoBusqueda: ""});
        }
        if (inputQ !== null){
            CambioIdioma.valida(var_ingles, inputQ);
        }
        if (estaActivo !== 0){
            setEstaActivo(0);
            _updateBotonClic({botonConsulta: estaActivo});
        }
        const handleDocumentClick = (event) => {
            if (!event.target.closest('#inputQ')) {  
                handleClickOutside();
            }
        };
        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    },[estaActivo]);   
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })  
    document.addEventListener('click', function(event) {
        let nodoTooltip = document.querySelectorAll('[role="tooltip"]');
        nodoTooltip.forEach(element => {
            element.remove();
        });
    });
return(
    <div className="row">
        <div className="slp-tbl_buscador slp-marginTB" id="rowinput" style= {{marginBottom:"0px"}}>
            <div className="slp-tbl-row_buscador">
                <div className="slp-tbl_col_buscador">
                    <div id="inputtodo" style={{paddingLeft: "0px", paddingRight:"1px"}}>
                        <div className="input-group" id="the-basics" style={{marginTop:"2px", flexWrap: "initial!important" }}>
                                <input
                                onKeyUp={keyUp}
                                id="inputQ"
                                style={{top:"3px",height:"34px"}}
                                type="text"
                                className="form-control"
                                ref={inputRef}
                                value={decodeURIComponent(inputValue)}
                                onChange={handleInputChange}
                                maxLength={"250"} 
                                placeholder={var_ingles === "es"? "Búsqueda...":"Search..."}
                                onKeyDown={handleKeyDown}
                                autoComplete="off"
                                />
                                <div className="btn-group">
                                    {
                                        showLimpiar && 
                                            <button className="btn btn-primary" 
                                            onClick={(event) => handleClick(event)}
                                            type="submit"
                                            style={{ position: "relative", width: "50px", borderBottomLeftRadius:"0px", borderTopLeftRadius:"0px"}} 
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            id="btnLimpiar"
                                            title={var_ingles==="es"? "Limpiar": "Clean"} 
                                            >
                                                <span className="inegi-cerrar " style={{verticalAlign: "text-bottom" }}></span>
                                            </button>
                                    }
                                    <button className="btn btn-primary" 
                                    onClick={(event) => handleClick2(event)} 
                                    aria-label="Boton de consulta"
                                    type="submit" 
                                    id="search"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={var_ingles==="es"? "Buscar": "Search"} 
                                    style={{ paddingLeft: "7px", width: "50px", borderBottomLeftRadius:"0px", borderTopLeftRadius:"0px"}}>
                                        <span className="inegi-buscar " style={{verticalAlign: "text-bottom"}}></span>
                                    </button>
                                </div>
                        </div>
                        {suggestions.length > 0 && (
                            <ul className='react-autosuggest_UL' id="Sugerencias" style={coleccion === "Todo"? {paddingTop: "10px", paddingLeft:"15px" }: {height: "70px", paddingTop: "10px", paddingLeft:"15px"}}>{/*overflow: "scroll"*/}
                                {suggestions.map((suggestion, index) => (
                                    suggestion.TITULO !="" && index <=10?
                                    <div className= {"react-_suggestion " + `suggestion-item ${index === activeIndex ? 'active' : ''}`}  
                                        aria-selected={index === activeIndex} 
                                        onMouseEnter={() => setActiveIndex(index)} 
                                        key={index} 
                                        onClick={() => handleSuggestionClick(suggestion)}>
                                            {highlightTexto(suggestion.TITULO)}
                                    </div>
                                    :""
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>             
) ;          
}

